module.exports = "/static/assets/e3d78d21ed4c075daac30a71a31ed54c.png";